import React from 'react';
import { Container, Image,Button} from 'react-bootstrap';
import './Project.css'
import project1 from '../images/red onion.png'
import project2 from '../images/panda comerce.png'
import project3 from '../images/bicycle selling.png'
import project4 from '../images/travel agnecy.png'
import project5 from '../images/health care medical.png'
import project6 from '../images/tempature.png'


const Project = () => {
    return (
        <div>
           <h3 id='project' className="text-center mt-5" style={{fontSize:"30px",fontWeight:'bold', fontFamily:'cursive'}}>My Awesome <span style={{fontSize:"30px",fontWeight:'bold',color:'#0FDCDC'}}>Work</span></h3>

           <Container>
           <div className="row img-container text-center mt-5">

           <div style={{position:'relative',overflow:'hidden'}} className=" live-buttton col-md-4 ">              
               <Image className="first" style={{width:'100%',height:'450px'}} src={project3} alt=""/>
                <div className="middle">    
                <a href="https://bicycle-selling-website.web.app/" target='blank'><Button className='ms-2'> Live View</Button></a>
               
                </div>
                <button className='btn btn-success mt-3'> See Project Details</button>
                <h4 className='mt-3'>Gravity Bicycle Hub</h4>
                <p>Build a Online Bicycle Selling platfrom.Its is full stack project build with React And Node Js Technology</p>
               </div>

             
               <div style={{position:'relative',overflow:'hidden'}} className=" live-buttton col-md-4 ">              
               <Image className="first" style={{width:'100%',height:'450px'}} src={project1} alt=""/>   
                <div className="middle">    
                <a href="https://red-onion-resturent-1c59f.web.app/" target='blank'><Button className='ms-2'> Live View</Button></a>
               
                </div>
                <button className='btn btn-success mt-3'> See Project Details</button>
                <h4 className='mt-3'>Red Onion Resturent</h4>
                <p>Build a Online Food Order Resturent.Its a simple simple figma to html template design.And data comes frome API</p>
               </div>
      

               <div style={{position:'relative',overflow:'hidden'}} className=" live-buttton col-md-4 ">              
               <Image className="first" style={{width:'100%',height:'450px'}} src={project2} alt=""/>
                <div className="middle">    
                <a href="https://hridoy01-hash.github.io/Panda-E-comerce/" target='blank'><Button className='ms-2'> Live View</Button></a>
               
                </div>
                <button className='btn btn-success mt-3'> See Project Details</button>
                <h4 className='mt-3'>Panda E-commerce Shop</h4>
                <p>Its a Online E-commerce shop project.Its a simple static online shop demo.Uses key elemets are plain HTML,CSS,Tailwind</p>
               </div>


               


               <div style={{position:'relative',overflow:'hidden',marginTop:'50px'}} className=" live-buttton col-md-4 ">              
               <Image className="first" style={{width:'100%',height:'450px',marginTop:'15px'}} src={project4} alt=""/>
                <div className="middle">    
                <a href="https://travel-vacation-resort.firebaseapp.com/" target='blank'><Button className='ms-2'> Live View</Button></a>
               
                </div>
                <button className='btn btn-success mt-3'> See Project Details</button>
                <h4 className='mt-3'>Green Travel Agency</h4>
                <p>Build a Online tour Services Provider Agency.Firebase Authentication system implements.A login user can booked any services</p>
               </div>


               <div style={{position:'relative',overflow:'hidden',marginTop:'50px'}} className=" live-buttton col-md-4 ">              
               <Image className="first" style={{width:'100%',height:'450px'}} src={project5} alt=""/>
                <div className="middle">    
                <a href="https://sheba-health-care.web.app/" target='blank'><Button className='ms-2'> Live View</Button></a>
               
                </div>
                <button className='btn btn-success mt-3'> See Project Details</button>
                <h4 className='mt-3'>Sehba Health Care</h4>
                <p>Online telimedicine services project.A login user can consultant with a doctor in this platfrom.Uses main Technology is React,JavaScript,Firebase</p>
               </div>


               <div style={{position:'relative',overflow:'hidden',marginTop:'50px'}} className=" live-buttton col-md-4 ">              
               <Image className="first" style={{width:'100%',height:'450px'}} src={project6} alt=""/>
                <div className="middle">    
                <a href="https://reverent-easley-2075a1.netlify.app/" target='blank'><Button className='ms-2'> Live View</Button></a>
               
                </div>
                <button className='btn btn-success mt-3'> See Project Details</button>
                <h4 className='mt-3'>Hot Live Weather Update</h4>
                <p>You can find weather update in any place.Weather live updated with Tempature API.Uses Materials are HTML,CSS,JSON API.</p>
               </div>



           </div>
           </Container>

        </div>
    );
};

export default Project;